<template>
  <div class="market-status">
    <Row :has-line="false">
      <template #icon-left>
        <InitialAvatarIcon :class="marketIconClass" :icon="status.icon" />
      </template>
      <template #top-left>
        <BaseText size="p5" :color="NebraskaColors.elementPrimary">
          {{ status.label }}
        </BaseText>
      </template>
      <template #top-right>
        <BaseText size="p5">{{ status.value }}</BaseText>
      </template>
    </Row>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';

import { Row, InitialAvatarIcon, BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { IMarketStatus } from '@/modules/catalog/services/products';

interface Props {
  status: IMarketStatus;
}

const props = defineProps<Props>();

const marketIconClass = computed(() => {
  return props.status.isMarketOpen
    ? 'market-status__icon-open'
    : 'market-status__icon-closed';
});
</script>
<style lang="less" scoped>
.market-status {
  padding: @size-spacing-x350 @size-spacing-x400;
  border-bottom: @size-border-x400 solid @divider-primary;

  &__icon-open {
    color: @status-positive;
    background: @status-positive-background;
  }

  &__icon-closed {
    color: @status-info;
    background: @status-info-background;
  }
}
</style>
